const initialState = [];

export default function downloadsReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_DOWNLOADS_SUCCESS': {
      return action.payload;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/downloads/reducer.js